import { render, staticRenderFns } from "./CarouselParallax.vue?vue&type=template&id=3e85c694&scoped=true&"
import script from "./CarouselParallax.vue?vue&type=script&lang=js&"
export * from "./CarouselParallax.vue?vue&type=script&lang=js&"
import style0 from "./CarouselParallax.vue?vue&type=style&index=0&id=3e85c694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e85c694",
  null
  
)

export default component.exports